/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { dealerInformationStyles } from "@insite/content-library/Widgets/DealerDetails/DealerInformation";
import ChevronLeft from "@monsma/XDL/Icons/ChevronLeft";
import { css } from "styled-components";

dealerInformationStyles.container = {
    gap: 0,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsGridItem = {
    width: 12,
    css: css`
        padding: 30px 0;
    `,
};

dealerInformationStyles.selectedDealerDisplayBackToResultsLink = {
    icon: {
        iconProps: {
            src: ChevronLeft,
            color: "common.ui5",
            size: 11,
            css: css`
                margin-right: 5px;
            `,
        },
        position: "left",
    },
};

dealerInformationStyles.nameGridItem = {
    width: 12,
    css: css`
        padding-bottom: 25px;
    `,
};

dealerInformationStyles.nameText = {
    color: "secondary",
    weight: "bold",
    size: 28,
    lineHeight: "42px",
};

dealerInformationStyles.addressInfoIcon = {
    css: css`
        display: none;
    `,
};

dealerInformationStyles.addressInfoCondensed = {
    wrapper: {
        css: css`
            font-size: 13px;
            line-height: 22px;
            font-style: normal;
        `,
    },
};

dealerInformationStyles.phoneLink = {
    typographyProps: {
        lineHeight: "22px",
        size: 13,
    },
};

dealerInformationStyles.htmlContentGridItem = {
    width: 12,
};

dealerInformationStyles.googleMapsDirectionLinkGridItem = {
    width: 3,
    css: css`
        padding-top: 10px;
    `,
};

dealerInformationStyles.visitWebsiteLinkGridItem = {
    width: 6,
    css: css`
        padding-top: 10px;
    `,
};
